export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null
}

/**
 * @description Error を継承しない例外も stack を持つことがあるため、instanceof ではなく構造で判定する
 */
export const getErrorStack = (value: unknown): string | undefined => {
  return isRecord(value) && typeof value.stack === 'string' ? value.stack : undefined
}

export const getErrorCode = (value: unknown): number | string | undefined => {
  if (!isRecord(value)) {
    return undefined
  }

  return typeof value.code === 'number' || typeof value.code === 'string' ? value.code : undefined
}

export const toError = (value: unknown): Error => {
  return value instanceof Error ? value : new Error(String(value))
}

/**
 * @description エラー処理の中で使うため、循環参照でJSON.stringifyがthrowしても二次障害にしない
 */
export const stringifyError = (value: unknown): string => {
  try {
    return JSON.stringify(value) ?? String(value)
  } catch {
    return String(value)
  }
}
